import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '..';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const useAdminNewLocationStore = defineStore('admin-new-location', {
    state: () => ({
        NewLocations:[]
    }),
    actions: {
        async loadNewLocations() {
            const alertStore = useAlertStore();
            try {
                const res = await fetchWrapper.get(`${baseUrl}/admin/new-location/load-new-locations`);
                this.NewLocations = res.totalNewLocations
            } catch (error) {
                alertStore.error(error);
            }
        },
        async createNewLocation(data) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/admin/new-location/create`, data);
                alertStore.success("New successfully added")

            } catch (error) {
                console.log(error)
                alertStore.error(error);
            }
        },
        async deleteNewLocations(newLocationIds) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/admin/new-location/delete`, { newLocationIds });
                alertStore.success("Delete successful")
            } catch (error) {
                alertStore.error(error);
            }
        },
        async deliveryNewLocation(newLocationId) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/admin/new-location/delivery`, { newLocationId } );
                alertStore.success("Delivery successful")

            } catch (error) {
                alertStore.error(error);
            }
        },
        
    },
});